import { Const } from 'auth-common/shared';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const isGnaviPinnedAtom = atomWithStorage<boolean>(Const.LocalStorage.IsGnaviPinned, false, undefined, {
  getOnInit: true,
});
export const useIsGnaviPinned = () => {
  const [isGnaviPinned, setIsGnaviPinned] = useAtom(isGnaviPinnedAtom);
  return { isGnaviPinned, setIsGnaviPinned };
};
